import React from "react";
import HeroSEction from "../../Components/home/HeroSEction";
import TopDestinations from "../../Components/Tour/TopDestinations";
import OurRecords from "../../Components/Tour/OurRecords";
import VehicleService from "../../Components/Tour/VehicleService";
import TrendingTours from "../../Components/home/TrendingTours";
import Newsletter from "../../Components/home/Newsletter";
import WhyChooseUs from "../../Components/About Us/WhyChooseUs";
import ClientsTestimonials from "../../Components/About Us/ClientsTestimonials";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          GoCabz – Reliable Cab Booking Service in Bhubaneswar | Fast, Safe
          Rides
        </title>
        <meta
          name="description"
          content="GoCabz offers fast, reliable and safe cab booking services in Bhubaneswar. Book
your ride easily via app or web. 24/7 service. Your comfort, our drive."
        />
        <meta
          name="keywords"
          content="cab service Bhubaneswar, taxi booking Bhubaneswar, cab app Odisha, safe rides, GoCabz"
        />
        <link rel="canonical" href="https://www.gocabz1.com" />
      </Helmet>
      <HeroSEction />
      <WhyChooseUs />
      <TrendingTours />
      <TopDestinations />
      <OurRecords />
      <ClientsTestimonials />
      <VehicleService />
      <Newsletter />
    </div>
  );
};

export default Home;
